import React, { useEffect } from 'react';
import { observer, inject } from 'mobx-react';
import styles from './colorPanel.scss';
import classNames from 'classnames';
import { IVariantStore } from '../../../types/index';
import { CustomSwiper } from '../customeSwiper/customeSwiper';
import TabNavigationHelper from '../../../helper/tabNavigationHelper';

export const ColorPanel = inject('variantStore')(
    observer(({ variantStore }: IVariantStore) => {
        const tabNavigation = TabNavigationHelper.instance;
        const isMobile = variantStore?.mainStore.isMobileShop;
        let selectedColor = variantStore?.selectedColor;
        const availableColors = variantStore?.variantSelectionCopy.availableColors;
        const tmpSelectedColorIndex = availableColors?.findIndex(color => {
            return color.code === selectedColor?.code;
        });
        const selectedColorIndex = tmpSelectedColorIndex ? tmpSelectedColorIndex : 0;
        const swiperColumns = availableColors ? Math.ceil(availableColors.length / 2) : 0;
        const selectedSwiperIndex = selectedColorIndex > swiperColumns ?
            selectedColorIndex % swiperColumns : selectedColorIndex;
        const shouldShowImage =
            isMobile && !!variantStore && variantStore.variantSelectionCopy.selectedColor &&
            variantStore.variantSelectionCopy.selectedColor.code > 0;

            useEffect(()=>{
                const elem = document.getElementsByClassName('pdp-selected')[0];
                window.shell.tabNav.focus(elem)
            })
        function handleColorClick(event) {
            event.preventDefault();
            event.stopPropagation();
            const target = event.currentTarget as HTMLElement;
            const colorCode = target.dataset.colorcode;
            if (colorCode) {
                const selectedColorInternal = availableColors?.find(
                    availableColor => availableColor.code == parseInt(colorCode)
                );

                if (selectedColorInternal) {
                    selectedColor = { code: selectedColorInternal.code, name: selectedColorInternal.name };
                    variantStore?.changeSelectedColor(selectedColor);
                }
            }
        }

        return (
            <>
                <div role='region' aria-label='color content wrapper' 
                    data-testid='color_content_wrapper' data-semantic-id='color_content_wrapper'
                    className={styles.color_content_wrapper}>
                    {isMobile ? (
                        <label className={styles.choosen_color_label}>
                            {variantStore?.mainStore.localization.generalL10n.selection}:{' ' + selectedColor?.name}
                        </label>
                    ) : null}
                    <div role='region' aria-label='color content' className={styles.color_content}
                        data-testid='color_content' data-semantic-id='color_content'>
                        <div role='region' aria-label='color icons' 
                            className={styles.color_icons}
                            data-testid='color_icons' data-semantic-id='color_icons'
                            ref={(el)=>tabNavigation.setGroupAtt(el)}>
                            <CustomSwiper
                                type='color'
                                selectedElementIndex={selectedSwiperIndex}
                                slidesPerColumn={2}
                                columnsPerView={5}
                                enabled={!!isMobile}
                            >
                                {availableColors?.map((availableColor, index) =>
                                (
                                    <a
                                        key={index}
                                        className={classNames(styles.color_border, {
                                            'pdp-selected': selectedColorIndex === index,
                                        })}
                                        data-colorcode={availableColor.code}
                                        onClick={handleColorClick}
                                        href={variantStore?.getUrlByAvailableColor(availableColor)}
                                        onKeyDown={(e)=> {
                                            if(e.key === ' '){
                                                handleColorClick(e)
                                            }
                                        }}
                                        title={
                                            variantStore?.mainStore.dataStore.orderModule.articleInfo.title + ' ' +
                                            availableColor.name}
                                            ref={(el)=>tabNavigation.setFocusAtt(el)}
                                    >
                                        <img
                                            className={styles.color_icon}
                                            src={availableColor.iconPath}
                                            title={availableColor.name}
                                            alt={variantStore?.mainStore.localization.generalL10n.colorIcon + ' ' +
                                                availableColor.name}
                                        ></img>
                                    </a>
                                ))}
                            </CustomSwiper>
                            {!isMobile ? (
                                <label className={styles.choosen_color_label}>
                                    {variantStore?.mainStore.localization.generalL10n.selection}:{' ' + selectedColor?.name}
                                </label>
                            ) : null}
                        </div>
                        {shouldShowImage && (
                            <>
                                <hr />
                                <div className={styles.image_content}>
                                    <img
                                        data-testid='side_image' data-semantic-id='side_image'
                                        className={styles.side_image}
                                        src={variantStore?.sideImagePath}
                                    />
                                </div>
                            </>
                        )}
                    </div>
                </div>
            </>
        );
    })
);

